var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xl12":""}},[_c('h2',[_vm._v("Contatos "),_c('span',{staticClass:"text-title-header"},[_vm._v(" | Ligamos para você")])]),_c('v-divider'),_c('br'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }